'use strict';

export default class ActivateRequestedController {
  errors = {
    forgot: undefined
  };
  submitted = false;

  /*@ngInject*/
  constructor($state, $stateParams, RequestedUserService, dialogs, Config) {

    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.RequestedUserService = RequestedUserService;
    this.dialogs = dialogs;

    RequestedUserService.get({id: $stateParams.id}, requestedUser => {
      this.user = requestedUser;
      this.user.password = '';
      this.user.confirmPassword = '';
    });
  }

  submit(form) {
    this.submitted = true;

    if(form.$valid) {
      this.RequestedUserService.activate({id: this.user._id},{
        email: this.user.email,
        password: this.user.password
      }, user => {
        let dlg = this.dialogs.notify("Account Activated", "You have successfully activated your account.<br/>You can now login with your email and password.");
        dlg.result.then(() => {
          this.$state.go("login");
        }, () => {
          this.$state.go("main");
        });
      },
        err => {
          alert(err.message);
        });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/account/activate-requested/activate-requested.controller.js